<template>
  <div class="mb-10">
    <HeaderBar :title="hTitle" />
    <div class="flex justify-center">
      <div>
        <div>
          <!-- table  -->
          <div class="border border-gray-800 my-4">
            <Table2Col :tableList="tableList" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import HeaderBar from "../../components/HeaderBar.vue";
import Table2Col from "../../components/Table2Col.vue";
export default {
  data() {
    return {
      tableList: [
        // {
        //   a: "Reservation Number / Contract Number",
        //   b: "You will get your 13-digit GIS reservation number and 13-digit contract number from your Seller. You will need these to settle your payments due.",
        // },
        {
          a: "Contract Number",
          b: "Your 13-digit contract number is indicated in the Welcome Letter that will be sent to you shortly after your reservation date. You will need your contract number when settling payments.",
        },
        {
          a: "Proof of Payment",
          b: "Always send your proof of payment to billing@moldex.com.ph so your payment may be endorsed for validation and posted to your account.",
        },
        // {
        //   a: "Pull-out Checks",
        //   b: "Requesting to pull-out checks require at least 7 working days lead time before the date of the check. This will also require Management approval first",
        // },
        // {
        //   a: "Multiple Post Dated Checks",
        //   b: "Issuance of multiple post dated checks is not allowed if your account is delayed. You will need to update your account by settling the amount required prior issuing the PDCs.",
        // },
        {
          a: "Pull-out Checks",
          b: "Requesting to pull-out checks require at least 7 working days lead time before the date of the check. This will also require Management approval first.",
        },
        {
          a: "Penalties",
          b: "Your account will automatically incur 5% penalties of the total arrears once your payment is delayed and/or insufficient.",
        },
        // {
        //   a: "Down Payment Stage",
        //   b: " There is no grace period for the down payment stage. Therefore, if your due date lands on a holiday or weekend, you will need to settle your payment before that holiday or weekend to avoid late posting of your payment and to furthermore avoid incurring penalties.",
        // },
        // {
        //   a: "Submitting Requests",
        //   b: "Any requests submitted will be subject for Management approval. Your original terms will be in effect until otherwise advised by Moldex Customer Service Department. Processing fees may be applied upon approval of the request.",
        // },
      ],
    };
  },
  props: ["hTitle"],
  components: { HeaderBar, Table2Col },
};
</script>